import generateTableColumnDescription from './tableColumn.js';

/**
 * Generates columns description.
 * This is optional and is skipped unless a column has some `style` defined.
 * @param  {object[]} options.schema
 * @param  {object[]} options.columns
 * @return {string}
 */
export default function generateTableColumns({ schema, columns }) {
    if (schema || columns) {
        // `tableColumns` format is described here:
        // https://learn.microsoft.com/en-us/dotnet/api/documentformat.openxml.spreadsheet.tablecolumns
        const description = (schema || columns)
            .map(generateTableColumnDescription)
            .join('');
        if (description) {
            return `<tableColumns count="${
                (schema || columns).length
            }">${description}</tableColumns>`;
        }
    }
    return '';
}
